<template>
	<Loader v-if="loading" />
	<div v-else>

		<div class="content padding-bottom">

			<h1>Translations</h1>

			<div class="flex margin-top">
				<div class="flex-grow">
					<label>Show translations</label>
					<select class="small-margin-left" v-model="show_translations">
						<option value="all">All Translations</option>
						<option value="missing">Missing Translations</option>
					</select>
				</div>
				<div class="flex-grow">
					<input type="text" placeholder="Create new ID" :disabled="saving" v-model="create_string_id" v-on:keyup.enter="createString()" />
					<select class="small-margin-left" v-model="create_locale">
						<option value="">In all languages</option>
						<option
						:key="locale.id"
									v-for="locale in getLocales"
									:value="locale.id">{{ locale.locale }}</option>
					</select>
					<div v-if="create_string_id" class="small-margin-top note">
						Press <strong>ENTER</strong> to create translation
					</div>
				</div>
				<div class="text-right">
					<input type="text" placeholder="Search" v-model="search" />
					<select class="small-margin-left" v-model="search_locale">
						<option value="">All languages</option>
						<option
						:key="locale.id"
									v-for="locale in getLocales"
									:value="locale.id">{{ locale.locale }}</option>
					</select>
				</div>
			</div>

		</div>
		<div class="content">
			<table class="basic">
				<thead>
					<tr>
						<th width="15%">#</th>
						<th width="15%">Label ID</th>
						<th width="15%">Language</th>
						<th width="55%">Translation</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="translation in getTranslations" :key="translation.id">
						<td>{{ translation.id }}</td>
						<td>{{ translation.string_id }}</td>
						<td>
							<Flag :localeid="translation.locale_id" />
						</td>
						<td>
							<div v-if="open_editors.indexOf(translation.id) >= 0">
								<textarea class="small-margin-bottom" cols="70" rows="6" :disabled="saving" v-model="translation.translation"></textarea>
								<div>
									<button :disabled="saving" v-on:click="update(translation.id)">Save</button>
									<button class="small-margin-left" :disabled="saving" v-on:click="toggleEditor(translation.id)">Close</button>
								</div>
							</div>
							<div v-else v-on:click="toggleEditor(translation.id)" class="clickable">
								<pre v-if="translation.translation">{{ translation.translation }}</pre>
								<em v-else>[ Click here to edit ]</em>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    loading: false,
    saving: false,
    translations: [],
    search: '',
    search_locale: '',
    create_locale: '',
    create_string_id: '',
    open_editors: [],
    show_translations: 'all',
    selected_translations: []
  }),
  computed: {
    ...mapGetters([
      'getLocales'
    ]),
    getTranslations () {
      if (!this.search) {
        return this.translations
      }
      return this.translations.filter(row => {
        var result = false

        if (row.translation.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) {
          result = true
        }

        if (row.string_id.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) {
          result = true
        }

        if (this.search_locale && row.locale_id !== Number(this.search_locale)) {
          result = false
        }

        return result
      })
    }
  },
  methods: {
    load () {
      Vue.api.get('/translation/all', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => {
          const groupData = _.values(_.groupBy(_.reverse(data), 'string_id'))
          const arr = []
          _.forEach(groupData, function (value) {
            value.map(function (v) {
              arr.push(v)
            })
          })
          this.translations = arr
          this.selected_translations = arr
        }
      })
    },
    toggleEditor (id) {
      if (this.open_editors.indexOf(id) >= 0) {
        this.open_editors = this.open_editors.filter(row => row !== id)
      } else {
        this.open_editors.push(id)
      }
    },
    update (id) {
      Vue.api.put('/translation/' + id, {
        translation: this.translations.filter(row => row.id === id)[0].translation
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.toggleEditor(id)
      })
    },
    createString () {
      var locales = {}
      if (this.create_locale) {
        locales[this.create_locale] = {}
      } else {
        locales = {
          1: {},
          2: {},
          3: {},
          4: {}
        }
      }

      Vue.api.post('/translation', {
        locales: locales,
        string_id: this.create_string_id
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => {
          this.create_string_id = ''
          this.load()
        }
      })
    },
    getLanguage (locale_id) {
      switch (locale_id) {
        case 1:
          return 'Danish'
        case 2:
          return 'Swedish'
        default:
          return 'Unknown'
      }
    }
  },
  created () {
    this.load()
  },

  watch: {
    show_translations () {
      this.translations = this.selected_translations.filter(row => {
        if (this.show_translations === 'missing') {
          return row.translation === ''
        } else {
          return row
        }
      })
    }
  }
}
</script>
